// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"143":"e49ad19d","781":"1ba3911d"}[chunkId] + ".css";
};